export const states1 = [
  {
    key: 'AL',
    value: 'AL',
    text: 'AL-Alabama',
  },
  {
    key: 'AK',
    value: 'AK',
    text: 'AK-Alaska',
  },
  {
    key: 'AZ',
    value: 'AZ',
    text: 'AZ-Arizona',
  },
  {
    key: 'AR',
    value: 'AR',
    text: 'AR-Arkansas',
  },
  {
    key: 'CA',
    value: 'CA',
    text: 'CA-California',
  },
  {
    key: 'CO',
    value: 'CO',
    text: 'CO-Colorado',
  },
  {
    key: 'CT',
    value: 'CT',
    text: 'CT-Connecticut',
  },
  {
    key: 'DE',
    value: 'DE',
    text: 'DE-Delaware',
  },
  {
    key: 'FL',
    value: 'FL',
    text: 'FL-Florida',
  },
  {
    key: 'GA',
    value: 'GA',
    text: 'GA-Georgia',
  },
  {
    key: 'HI',
    value: 'HI',
    text: 'HI-Hawaii',
  },
  {
    key: 'ID',
    value: 'ID',
    text: 'ID-Idaho',
  },
  {
    key: 'IL',
    value: 'IL',
    text: 'IL-Illinois',
  },
  {
    key: 'IN',
    value: 'IN',
    text: 'IN-Indiana',
  },
  {
    key: 'IA',
    value: 'IA',
    text: 'IA-Iowa',
  },
  {
    key: 'KS',
    value: 'KS',
    text: 'KS-Kansas',
  },
  {
    key: 'KY',
    value: 'KY',
    text: 'KY-Kentucky',
  },
  {
    key: 'LA',
    value: 'LA',
    text: 'LA-Louisiana',
  },
  {
    key: 'ME',
    value: 'ME',
    text: 'ME-Maine',
  },
  {
    key: 'MD',
    value: 'MD',
    text: 'MD-Maryland',
  },
  {
    key: 'MA',
    value: 'MA',
    text: 'MA-Massachusetts',
  },
  {
    key: 'MI',
    value: 'MI',
    text: 'MI-Michigan',
  },
  {
    key: 'MN',
    value: 'MN',
    text: 'MN-Minnesota',
  },
  {
    key: 'MS',
    value: 'MS',
    text: 'MS-Mississippi',
  },
  {
    key: 'MO',
    value: 'MO',
    text: 'MO-Missouri',
  },
  {
    key: 'MT',
    value: 'MT',
    text: 'MT-Montana',
  },
  {
    key: 'NE',
    value: 'NE',
    text: 'NE-Nebraska',
  },
  {
    key: 'NV',
    value: 'NV',
    text: 'NV-Nevada',
  },
  {
    key: 'NH',
    value: 'NH',
    text: 'NH-New Hampshire',
  },
  {
    key: 'NJ',
    value: 'NJ',
    text: 'NJ-New Jersey',
  },
  {
    key: 'NM',
    value: 'NM',
    text: 'NM-New Mexico',
  },
  {
    key: 'NY',
    value: 'NY',
    text: 'NY-New York',
  },
  {
    key: 'NC',
    value: 'NC',
    text: 'NC-North Carolina',
  },
  {
    key: 'ND',
    value: 'ND',
    text: 'ND-North Dakota',
  },
  {
    key: 'OH',
    value: 'OH',
    text: 'OH-Ohio',
  },
  {
    key: 'OK',
    value: 'OK',
    text: 'OK-Oklahoma',
  },
  {
    key: 'OR',
    value: 'OR',
    text: 'OR-Oregon',
  },
  {
    key: 'PA',
    value: 'PA',
    text: 'PA-Pennsylvania',
  },
  {
    key: 'RI',
    value: 'RI',
    text: 'RI-Rhode Island',
  },
  {
    key: 'SC',
    value: 'SC',
    text: 'SC-South Carolina',
  },
  {
    key: 'SD',
    value: 'SD',
    text: 'SD-South Dakota',
  },
  {
    key: 'TN',
    value: 'TN',
    text: 'TN-Tennessee',
  },
  {
    key: 'TX',
    value: 'TX',
    text: 'TX-Texas',
  },
  {
    key: 'UT',
    value: 'UT',
    text: 'UT-Utah',
  },
  {
    key: 'VT',
    value: 'VT',
    text: 'VT-Vermont',
  },
  {
    key: 'VA',
    value: 'VA',
    text: 'VA-Virginia',
  },
  {
    key: 'WA',
    value: 'WA',
    text: 'WA-Washington',
  },
  {
    key: 'WV',
    value: 'WV',
    text: 'WV-West Virginia',
  },
  {
    key: 'WI',
    value: 'WI',
    text: 'WI-Wisconsin',
  },
  {
    key: 'WY',
    value: 'WY',
    text: 'WY-Wyoming',
  },
];

export const states = [
  {
    key: 'AL',
    value: 'AL',
    text: 'Alabama',
  },
  {
    key: 'AK',
    value: 'AK',
    text: 'Alaska',
  },
  {
    key: 'AZ',
    value: 'AZ',
    text: 'Arizona',
  },
  {
    key: 'AR',
    value: 'AR',
    text: 'Arkansas',
  },
  {
    key: 'CA',
    value: 'CA',
    text: 'California',
  },
  {
    key: 'CO',
    value: 'CO',
    text: 'Colorado',
  },
  {
    key: 'CT',
    value: 'CT',
    text: 'Connecticut',
  },
  {
    key: 'DE',
    value: 'DE',
    text: 'Delaware',
  },
  {
    key: 'FL',
    value: 'FL',
    text: 'Florida',
  },
  {
    key: 'GA',
    value: 'GA',
    text: 'Georgia',
  },
  {
    key: 'HI',
    value: 'HI',
    text: 'Hawaii',
  },
  {
    key: 'ID',
    value: 'ID',
    text: 'Idaho',
  },
  {
    key: 'IL',
    value: 'IL',
    text: 'Illinois',
  },
  {
    key: 'IN',
    value: 'IN',
    text: 'Indiana',
  },
  {
    key: 'IA',
    value: 'IA',
    text: 'Iowa',
  },
  {
    key: 'KS',
    value: 'KS',
    text: 'Kansas',
  },
  {
    key: 'KY',
    value: 'KY',
    text: 'Kentucky',
  },
  {
    key: 'LA',
    value: 'LA',
    text: 'Louisiana',
  },
  {
    key: 'ME',
    value: 'ME',
    text: 'Maine',
  },
  {
    key: 'MD',
    value: 'MD',
    text: 'Maryland',
  },
  {
    key: 'MA',
    value: 'MA',
    text: 'Massachusetts',
  },
  {
    key: 'MI',
    value: 'MI',
    text: 'Michigan',
  },
  {
    key: 'MN',
    value: 'MN',
    text: 'Minnesota',
  },
  {
    key: 'MS',
    value: 'MS',
    text: 'Mississippi',
  },
  {
    key: 'MO',
    value: 'MO',
    text: 'Missouri',
  },
  {
    key: 'MT',
    value: 'MT',
    text: 'Montana',
  },
  {
    key: 'NE',
    value: 'NE',
    text: 'Nebraska',
  },
  {
    key: 'NV',
    value: 'NV',
    text: 'Nevada',
  },
  {
    key: 'NH',
    value: 'NH',
    text: 'New Hampshire',
  },
  {
    key: 'NJ',
    value: 'NJ',
    text: 'New Jersey',
  },
  {
    key: 'NM',
    value: 'NM',
    text: 'New Mexico',
  },
  {
    key: 'NY',
    value: 'NY',
    text: 'New York',
  },
  {
    key: 'NC',
    value: 'NC',
    text: 'North Carolina',
  },
  {
    key: 'ND',
    value: 'ND',
    text: 'North Dakota',
  },
  {
    key: 'OH',
    value: 'OH',
    text: 'Ohio',
  },
  {
    key: 'OK',
    value: 'OK',
    text: 'Oklahoma',
  },
  {
    key: 'OR',
    value: 'OR',
    text: 'Oregon',
  },
  {
    key: 'PA',
    value: 'PA',
    text: 'Pennsylvania',
  },
  {
    key: 'RI',
    value: 'RI',
    text: 'Rhode Island',
  },
  {
    key: 'SC',
    value: 'SC',
    text: 'South Carolina',
  },
  {
    key: 'SD',
    value: 'SD',
    text: 'South Dakota',
  },
  {
    key: 'TN',
    value: 'TN',
    text: 'Tennessee',
  },
  {
    key: 'TX',
    value: 'TX',
    text: 'Texas',
  },
  {
    key: 'UT',
    value: 'UT',
    text: 'Utah',
  },
  {
    key: 'VT',
    value: 'VT',
    text: 'Vermont',
  },
  {
    key: 'VA',
    value: 'VA',
    text: 'Virginia',
  },
  {
    key: 'WA',
    value: 'WA',
    text: 'Washington',
  },
  {
    key: 'WV',
    value: 'WV',
    text: 'West Virginia',
  },
  {
    key: 'WI',
    value: 'WI',
    text: 'Wisconsin',
  },
  {
    key: 'WY',
    value: 'WY',
    text: 'Wyoming',
  },
];



// WEBPACK FOOTER //
// ./src/common/Constants/states.js